import { type UseQueryResult, useQuery } from 'react-query';
import {
  OptionAwardService,
  // eslint-disable-next-line camelcase
  type PagedResultDto_AdminDashboardGrantList,
} from '../../services/wealthlane-award-services';
import { type TableParamsType } from '../../types/common';

const useGetOptionViewTableList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  tableInfo: TableParamsType,
  grantId: string,
  vestingDate: string
): UseQueryResult<
  // eslint-disable-next-line camelcase
  PagedResultDto_AdminDashboardGrantList | undefined,
  unknown
> => {
  const { filter, sorting, skipCount, maxResultCount } = tableInfo;
  const optionViewTableList = useQuery(
    ['getOptionViewTableList', tableInfo, grantId, vestingDate],
    async () => {
      return await handleRequest(
        OptionAwardService.getApiAwardApiAppOptionAwardAdminDashboardGrantList(
          vestingDate,
          grantId,
          filter,
          sorting,
          skipCount,
          maxResultCount
        )
      );
    }
  );

  return optionViewTableList;
};

export default useGetOptionViewTableList;
